<template>
  <div>
    <p class="cm-mg-p-wzd">2. {{ $t('common_words.varieties') }}</p>
    <hr />
    <div class="has-label mb-2">
      <label
        >{{ $t('common_words.variety_number') }}:
        <strong>{{ model.varieties_number }}</strong></label
      >
    </div>
    <div class="px-3">
      <div v-for="(_, index) in model.varieties_number" :key="index">
        <div class="row">
          <div class="col-10 col-md-11 col-lg-11">
            <fg-input
              class="required-fourth-step"
              v-model="model.variety_names[index]"
              type="text"
              :label="`${$t('common_words.variety_name')} ${index + 1}: *`"
              :placeholder="$t('common_words.williams')"
              name="common_words.variety_name"
              v-validate="modelValidations.variety_name"
              :error="
                getError('common_words.variety_name', true, {
                  '%1%': index + 1,
                })
              "
            ></fg-input>
          </div>
          <!-- Botones de acción por fila -->
          <div class="col-2 col-md-1 col-lg-1 d-flex align-items-center mt-3">
            <div class="btn-group" role="group">
              <button
                class="btn btn-danger custom-shadow-btn mr-2"
                @click.prevent="handleDelete(index, model.variety_names[index])"
              >
                <em class="fa fa-minus"></em>
              </button>

              <button
                v-if="index === model.varieties_number - 1"
                class="btn btn-success custom-shadow-btn"
                @click.prevent="handlePlus()"
              >
                <em class="fa fa-plus"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {},
  data() {
    return {
      model: {
        varieties_id: [],
        varieties_number: 1,
        variety_names: [],
      },
      modelValidations: {
        variety_name: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinValidations],
  methods: {
    handlePlus() {
      this.model.varieties_number++;
      this.model.varieties_id.push(null);
      this.model.variety_names.push('');
    },
    handleDelete(index, name) {
      if (name) {
        SweetAlert.delete(name).then((result) => {
          if (result.value) this.handleMinus(index);
        });
      } else {
        this.handleMinus(index);
      }
    },
    handleMinus(index = null) {
      if (this.model.varieties_number > 1) {
        this.model.varieties_id.splice(index, 1);
        this.model.variety_names.splice(index, 1);
        this.model.varieties_number--;
      } else {
        this.model.varieties_id = [];
        this.model.variety_names = [];
        this.model.varieties_number = 1;
      }
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', this.model);
        return res;
      });
    },
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const { crop_varieties } = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.varieties_number = crop_varieties.length;
      crop_varieties.forEach(({ id, name }) => {
        this.model.varieties_id.push(id);
        this.model.variety_names.push(name);
      });
    }
  },
};
</script>
<style></style>
